<template>
  <div id="app">
    <v-app>
      <div v-if="showModal">
        <Modal @click="closeDialog" :title="modalValues.title" :type="modalValues.type" :message="modalValues.messages"
          :show="modalValues.show" :size="modalValues.size" :theme="modalValues.theme" :accion="modalValues.accion" />
      </div>
      <router-view />
    </v-app>
  </div>
</template>

<script>
import Modal from '@/components/dialog/ModalDialog.vue';
/* import appService from '@/services/appService';
import { promoEnums } from './components/util/promocionEnum'; */
export default {
  data() {
    return {
      interval: null,
      time: 0,
      version: 0,
      showModal: false,
      modalValues: {
        title: null,
        type: null,
        messages: null,
        show: null,
        size: null,
        theme: null,
        accion: null
      },
    }
  },
  components: {
    Modal
  },
  computed: {
  },
  methods: {
    openDialog(title, type, message, show, size, theme, accion) {
      this.showModal = true;
      this.modalValues = {
        title: title,
        type: type,
        messages: message,
        show: show,
        size: size,
        theme: theme,
        accion: accion,
      }
    },
    closeDialog() {
      this.showModal = false
    },
    /* async getPromocion() {
      let respuesta = await appService.consultaPromocion();

      let data = respuesta.data.data;
      console.log(data)

      this.loadPagePromo(parseInt(data));

    },
    loadPagePromo(valor) {
      console.log(valor)

      switch (valor) {
        case promoEnums.DATOS:
          if (this.$route.path !== '/promociones/descuento') {
            this.$router.push({ path: '/promociones/descuento' })
          }
          break;
        case promoEnums.DIAMADRE:
          if (this.$route.path !== '/promociones/diamadre') {
            this.$router.push({ path: '/promociones/diamadre' })
          }
          break;
        case promoEnums.SORTEO:
          if (this.$route.path !== '/promociones/sorteo') {
            this.$router.push({ path: '/promociones/sorteo' })
          }
          break;

        default:
          if (this.$route.name !== 'pageNotFound') {
            this.$router.push({ path: '/promociones/.' })
          }

      }

    }, */

    /*  intervalInit() {
       clearInterval(this.interval)
       this.interval = setInterval(() => {
         this.getVersionApp()
 
       }, this.getTimeIterval)
     }, */
    updatePage() {
    },
    /* reloadApp() {
      let params = {
        version: this.version,
        time: this.getTimeIterval,
      }
      console.log(params)
      this.setParamsData(params);
      window.location.reload();
      console.log("Actualizado")
    }, */
    /* async getVersionApp() {
      let respuesta = await appService.getVersionApp();
      let data = respuesta.data
      this.version = data.data
      if (this.version != this.getVersion) {
        console.log("version Nueva");
        this.openDialog("Actualizacion", 2, '<p>Existe una nueva version</p><p>¿Desea actualizar en este momento?</p>', true, '600', 'blue-grey darken-3', this.reloadApp);
      }

    }, */

  },
  async beforeMount() {
    // await this.getPromocion();
    //await this.getParamsApp();
    // await this.intervalInit();
  },
  destroyed() {
    // clearInterval(this.intervalo)
  }
}
</script>
<!-- <style>
.background-images {
  background: url('/src/assets/images/img-sorteo/fondo.png') no-repeat center center fixed;
  background-size: cover;
}
</style> -->

